import { render, staticRenderFns } from "./book-appointment.vue?vue&type=template&id=2143b220"
import script from "./book-appointment.vue?vue&type=script&lang=js"
export * from "./book-appointment.vue?vue&type=script&lang=js"
import style0 from "./book-appointment.vue?vue&type=style&index=0&id=2143b220&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports